module.exports = __webpack_public_path__ + "655d2682d24a98b38fd5f1bb59a52b20.png";